import styled from '@emotion/styled'

export const PageContainer = styled.div`
  background: #ffffff;
  color: #1f2937;
  width: 100%;
  min-width: 0;
`

export const MainContent = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 32px 40px;
  box-sizing: border-box;

  @media (min-width: 769px) {
    max-width: 1400px;
    margin: 0 auto;
  }

  @media (max-width: 768px) {
    padding: 16px 12px;
    min-width: 0;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 16px;
`

export const LoadingSpinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid rgba(var(--portal-primary-rgb, 124, 58, 237), 0.1);
  border-top-color: var(--portal-primary, #7c3aed);
  border-radius: 50%;
  animation: spin 1s linear infinite;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`

export const LoadingText = styled.div`
  font-size: 16px;
  color: #6b7280;
`

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  gap: 16px;
`

export const ErrorIcon = styled.div`
  font-size: 48px;
`

export const ErrorText = styled.div`
  font-size: 16px;
  color: #ef4444;
  text-align: center;
  max-width: 400px;
`

export const RetryButton = styled.button`
  padding: 12px 24px;
  background: var(--portal-primary, #7c3aed);
  border: none;
  border-radius: 8px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: var(--portal-primary-dark, #6d28d9);
  }
`

export const PageTitle = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 24px 0;

  @media (max-width: 768px) {
    font-size: 24px;
    margin-bottom: 16px;
  }
`

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 40vh;
  gap: 16px;
`

export const EmptyIcon = styled.div`
  font-size: 64px;
`

export const EmptyTitle = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #111827;
  margin: 0;
`

export const EmptyDescription = styled.p`
  font-size: 16px;
  color: #6b7280;
  text-align: center;
  max-width: 400px;
  margin: 0;
  line-height: 1.5;
`

export const ReceiptList = styled.div`
  display: grid;
  gap: 16px;
  grid-template-columns: 1fr;

  @media (min-width: 769px) {
    grid-template-columns: repeat(auto-fit, minmax(min(100%, 480px), 1fr));
    gap: 20px;
  }
`

export const ReceiptCard = styled.div`
  padding: 20px;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  transition: all 0.2s;
  cursor: pointer;

  &:hover {
    border-color: var(--portal-primary, #7c3aed);
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(var(--portal-primary-rgb, 124, 58, 237), 0.15);
  }
`

export const DetailOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
`

export const RefundedPill = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 600;
  background: rgba(239, 68, 68, 0.1);
  color: #ef4444;
`

// Receipt detail card components

export const DetailCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  max-width: 480px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 24px 48px rgba(0, 0, 0, 0.15);
  position: relative;
`

export const DetailCardCloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 36px;
  height: 36px;
  border: none;
  background: #f3f4f6;
  border-radius: 8px;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  color: #6b7280;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: #e5e7eb;
    color: #111827;
  }
`

export const DetailCardContent = styled.div`
  padding: 24px;
  padding-top: 56px;
`

export const DetailCardTopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 16px;
  flex-wrap: wrap;
`

export const DetailCardTitle = styled.h2`
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0;
`

export const DetailCardActionsRow = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`

export const DetailCardSsnToggle = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  background: transparent;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #374151;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f9fafb;
    border-color: #d1d5db;
  }
`

export const DetailCardDownloadButton = styled.button`
  padding: 8px 16px;
  background: var(--portal-primary, #7c3aed);
  border: none;
  border-radius: 8px;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;

  &:hover {
    background: var(--portal-primary-dark, #6d28d9);
  }
`

export const DetailCardSsnInputRow = styled.div`
  margin-bottom: 16px;
`

export const DetailCardReceiptBox = styled.div`
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 20px;
`

export const DetailCardReceiptRef = styled.div`
  font-size: 14px;
  color: #6b7280;
  font-weight: 500;
  margin-bottom: 12px;
`

export const DetailCardSellerBlock = styled.div`
  margin-bottom: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid #e5e7eb;
`

export const DetailCardSellerLabel = styled.div`
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #6b7280;
  margin-bottom: 4px;
`

export const DetailCardSellerValue = styled.div`
  font-size: 14px;
  color: #111827;
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const DetailCardReceiptRows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const DetailCardRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;
`

export const DetailCardRowLabel = styled.span`
  font-weight: 500;
  color: #6b7280;
  flex-shrink: 0;
`

export const DetailCardRowValue = styled.span`
  font-weight: 600;
  color: #111827;
  text-align: right;
`

export const DetailCardRefundNote = styled.div`
  margin-top: 12px;
  padding: 10px 14px;
  background: rgba(239, 68, 68, 0.08);
  border-radius: 8px;
  border: 1px solid rgba(239, 68, 68, 0.2);
  font-size: 13px;
  color: #dc2626;
`

export const DetailCardCloseFooter = styled.button`
  width: 100%;
  margin-top: 16px;
  padding: 12px;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #e5e7eb;
  }
`
